import { Route } from 'react-router-dom'
import TipoTerreno from './../pages/maestros/cotizaciones/TipoTerreno'
import TipoProyecto from './../pages/maestros/cotizaciones/TipoProyecto'
import FormasPago from './../pages/maestros/cotizaciones/FormasPago'
import Ubicaciones from './../pages/maestros/cotizaciones/Ubicaciones'
import Plazos from './../pages/maestros/cotizaciones/Plazos'
import Entregables from './../pages/maestros/cotizaciones/Entregables'
import Espacios from './../pages/maestros/cotizaciones/Espacios'
import Clausulas from '../pages/maestros/contratos/Clausula'
import Especialidades from '../pages/maestros/profesionales/Especialidades'
import Empresa from './../pages/maestros/Empresa'
import ProtectedRoute from './../components/ProtectedRoute'
import EmpresaDetalle from '../pages/maestros/EmpresaDetalle'


const MaestrosRoutes = () => (
  <>
    <Route path="/maestros" >
      <Route
        path="tipo-terreno"
        element={
          <ProtectedRoute requiredModule="maestros">
            <TipoTerreno />
          </ProtectedRoute>
        }
      />
      <Route
        path="tipo-proyecto"
        element={
          <ProtectedRoute requiredModule="maestros">
            <TipoProyecto />
          </ProtectedRoute>
        }
      />
      <Route
        path="formas-pago"
        element={
          <ProtectedRoute requiredModule="maestros">
            <FormasPago />
          </ProtectedRoute>
        }
      />
      <Route
        path="ubicaciones"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Ubicaciones />
          </ProtectedRoute>
        }
      />
       <Route
        path="empresa"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Empresa />
          </ProtectedRoute>
        }
      />
       <Route
        path="editar_empresa"
        element={
          <ProtectedRoute requiredModule="maestros">
            <EmpresaDetalle />
          </ProtectedRoute>
        }
      />
       <Route
        path="plazos"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Plazos/>
          </ProtectedRoute>
        }
      />
       <Route
        path="entregables"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Entregables/>
          </ProtectedRoute>
        }
      />
      <Route
        path="espacios"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Espacios/>
          </ProtectedRoute>
        }
      />
      <Route
        path="clausulas"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Clausulas/>
          </ProtectedRoute>
        }
      />
      <Route
        path="especialidades"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Especialidades/>
          </ProtectedRoute>
        }
      />
    </Route>
  </>
)

export default MaestrosRoutes
